module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isEmpty(_vm.author)) ? _c('div', {
    staticClass: "person-intro"
  }, [(!_vm.isEmpty(_vm.image)) ? _c('div', {
    staticClass: "row d-flex justify-content-center"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.image),
      expression: "image"
    }],
    staticClass: "img-fluid thumbnail",
    attrs: {
      "alt": _vm.title
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "introduction"
  }, [_c('div', {
    staticClass: "row justify-content-start pl-3 pr-3 pb-2 no-gutters"
  }, [_c('div', {
    staticClass: "col authorName"
  }, [_c('term-link', {
    attrs: {
      "tid": _vm.author.tid,
      "title": _vm.author.title,
      "url": _vm.author.relative_url,
      "type": _vm.author.type
    }
  }, [_vm._v(_vm._s(_vm.author.title))])], 1)]), (_vm.links) ? _c('div', {
    staticClass: "no-gutters row align-items-start pl-3 pr-3"
  }, _vm._l((_vm.links), function(link) {
    return _c('a', {
      key: link.type,
      staticClass: "social-box",
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_c(link.type, {
      tag: "component",
      staticClass: "social-icon",
      class: _vm.classes(link.type)
    })], 1)
  })) : _vm._e(), (_vm.bio) ? _c('div', {
    staticClass: "row intro-text p-3 "
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        " + _vm._s(_vm.bio) + "\n      ")])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13bbef60","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/common/PersonIntro.vue
// module id = 1172
// module chunks = 9 23